import React from 'react';
import { Modal, Text, Button, Group } from '@mantine/core';
import type { AuthSessionUser } from '@domain/auth/types';

type LogoutConfirmModalProps = {
  opened: boolean;
  onClose: () => void;
  onConfirm: () => void;
  currentUser?: AuthSessionUser | null;
  avatarUrl?: string;
  loading?: boolean;
};

export function LogoutConfirmModal({
  opened,
  onClose,
  onConfirm,
  loading = false,
}: LogoutConfirmModalProps) {
  return (
    <Modal
      opened={opened}
      onClose={onClose}
      title="退出登录"
      centered
      size="sm"
      radius="lg"
      padding="md"
      overlayProps={{ backgroundOpacity: 0.5, blur: 3 }}
      styles={{ body: { paddingTop: 'var(--mantine-spacing-md)' } }}
    >
      <Text size="sm" c="dimmed" mb="md">
        确定要退出当前账号吗？
      </Text>

      <Group justify="flex-end" gap="xs">
        <Button variant="default" size="sm" radius="md" onClick={onClose} disabled={loading}>
          取消
        </Button>
        <Button color="red" size="sm" radius="md" onClick={onConfirm} loading={loading}>
          退出登录
        </Button>
      </Group>
    </Modal>
  );
}
